// extracted by mini-css-extract-plugin
export default {"cls1":"Y_xgmhYKlhPkHKyHVQr5","cls2":"wWJKou4qmuSVuxWgW7Zw Y_xgmhYKlhPkHKyHVQr5","isPhone":"fkwMLnwmvSLRszt0Hi0w"};